import * as ReactDOM from "react-dom/client";
import VConsole from "vconsole";
import { RouterProvider } from "react-router-dom";
import { initSentry } from "@/utils/sentryUtils";
import { consoleAppInfo } from "@/utils/versionUtils";
import routes from "../config/routes";
import "./index.css";

initSentry();

consoleAppInfo();

if (process.env.REACT_APP_ENV !== "prod") {
  try {
    new VConsole();
  } catch (error) {
    console.log("new VConsole error", error);
  }
}

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(<RouterProvider router={routes} />);
